import React from 'react'
import { ATLGenericListItem, ButtonTypeEnum, GenericListItemRightElementEnum } from '@appsimples/atlantica-react-native'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { formatConfidentialCPF } from '../../utils/formatters'
import { Coordinator } from '../../navigation/coordinator/coordinator'

interface ProfilePersonalInfoProps {
  name: string
  email: string
  cpf: string
}

const Container = styled.View`
  margin-top: ${atlTheme.SpacingAtomic}px;
  border-bottom-start-radius: ${atlTheme.BorderRadiusCard}px;
  border-bottom-end-radius: ${atlTheme.BorderRadiusCard}px;
  background: ${atlTheme.ColorSurface};

  width: 100%;
`

export const ProfilePersonalInfo: React.FunctionComponent<ProfilePersonalInfoProps> = ({ name, email, cpf }) => {
  const displayCpf = formatConfidentialCPF(cpf)

  return (
    <Container>
      <ATLGenericListItem
        title={'Nome'}
        descriptionLine1={name}
        rightElement={GenericListItemRightElementEnum.button}
        actionButtonType={ButtonTypeEnum.outlined}
        textActionButton={'Alterar'}
        buttonBaseProps={{
          borderRadius: atlTheme.BorderRadius100,
        }}
        rightLabelBaseProps={{ multilineLimit: 1 }}
        titleLabelBaseProps={{ multilineLimit: 1 }}
        bodyLabelBaseProps={{ multilineLimit: 1 }}
        onPressActionButton={Coordinator.goToChangeNameScreen}
        dividerBaseProps={{
          color: atlTheme.ColorBackground,
        }}
      />
      <ATLGenericListItem
        title={'E-mail'}
        descriptionLine1={email}
        titleLabelBaseProps={{ multilineLimit: 1 }}
        bodyLabelBaseProps={{ multilineLimit: 1 }}
        dividerBaseProps={{
          color: atlTheme.ColorBackground,
        }}
      />
      <ATLGenericListItem
        title={'CPF'}
        titleLabelBaseProps={{ multilineLimit: 1 }}
        rightElement={GenericListItemRightElementEnum.label}
        rightStatusText={displayCpf}
        dividerBaseProps={{
          thickness: 0,
        }}
        verticalMargin={atlTheme.SpacingAtomic}
      />
    </Container>
  )
}
